<template>
  <div>
    <edit
      v-if="selected"
      :selected="selected"
      receiptType="tenant"
      ref="edit"
      @reload="$emit('reload')"
      ></edit>

    <div
      class="font-weight-medium primary lighten-2 white--text px-3 py-1"
      @click="expand = !expand"
      style="cursor: pointer"
      >
      <div
        class="d-flex flex-row"
        >
        <div>
          {{ payment[0] == 'null' ? 'Fuera de contrato' : payment[0] }}
        </div>

        <div
          class="ml-auto"
          v-if="payment[1].length"
          >
          <v-btn
            @click.stop="redirect"
            x-small
            >
            Ver contrato
            <v-icon
              small
              class="ml-1"
              style="margin-bottom: -1px"
              >
              mdi-arrow-right-circle-outline
            </v-icon>
          </v-btn>
        </div>
      </div>
    </div>

    <v-expand-transition>
      <div
        v-if="expand"
        class="text--primary"
        >
        <template
          v-for="(charge, i) in orderedCharges"
          v-if="charge.taxableTag != 'Building'"
          >
          <div
            class="d-flex align-center px-3"
            :class="{ 'ml-8': !(charge.concept == 'Alquiler' && i == 0), 'rounded-0': (charge.concept == 'Alquiler' && i == 0) }"
            :style="!(charge.concept == 'Alquiler' && i == 0) ? 'border-left: 1px solid #0000001f' : 'border: 1px solid #586279; border-left: 8px solid #586279'"
            style="gap: 8px"
            >
            <div>
              <v-icon
                color="primary"
                @click.stop="pay(charge)"
                >
                {{ charge.state == 'paid' ? 'mdi-check-circle' : 'mdi-check-circle-outline' }}
              </v-icon>
            </div>

            <v-row
              no-gutters
              class="mt-2"
              align="center"
              >
              <v-col
                cols="5"
                class="d-flex flex-row"
                style="gap: 4px"
                >
                <template
                  v-if="charge.parentId"
                  >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        color="primary"
                        size="20"
                        class="mt-n1"
                        dark
                        v-bind="attrs"
                        v-on="on"
                        >
                        mdi-source-branch
                      </v-icon>
                    </template>
                    <span>Es un pago parcial</span>
                  </v-tooltip>
                </template>

                <div>
                  <div
                    class="caption d-flex align-center"
                    style="gap: 4px"
                    >
                    #{{ charge.id }} {{ charge.taxableTag == 'Building' ? '- Expensas' : '' }}

                    <v-icon
                      v-if="charge.concept == 'Alquiler' && (charge.referralType == 'User' && charge.referralId == client.id)"
                      color="primary lighten-1"
                      size="18"
                      >
                      mdi-home
                    </v-icon>

                    <v-tooltip 
                      color="primary"
                      right>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-if="charge.thirdPartyTransfer"
                          v-on="on"
                          v-bind="attrs"
                          size="18"
                          style="margin-bottom: -2px"
                          color="primary lighten-1"
                          >
                          mdi-bank-transfer
                        </v-icon>
                      </template>
                      <span>Transferencia directa al locador por parte del locatario.</span>
                    </v-tooltip>
                  </div>

                  <div
                    class="text-body-2"
                    >
                    <span
                      class="font-weight-medium"
                      >
                      {{ charge.concept }}
                    </span>
                    - {{ (new Date(charge.dueDate)).toLocaleString('default', { month: 'long' }) }}
                  </div>
                </div>
              </v-col>

              <v-col
                cols="2"
                :class="charge.total >= 0 ? '' : 'red--text'"
                @click="select(charge)"
                >
                <div
                  v-if="charge.total < 0"
                  class="text-right font-weight-medium d-flex justify-end align-center"
                  :style="!(charge.concept == 'Alquiler' && i == 0) ? 'margin-right: 8px' : ''"
                  style="cursor: pointer; gap: 8px"
                  >
                  <template
                    v-if="charge.differential"
                    >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          color="primary"
                          size="20"
                          class="mt-n1"
                          dark
                          v-bind="attrs"
                          v-on="on"
                          >
                          mdi-alert-circle
                        </v-icon>
                      </template>
                      <span>Diferencia de pago en pagaré</span>
                    </v-tooltip>
                  </template>

                  <template
                    v-if="charge.chargebacks.length"
                    >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          color="primary"
                          size="20"
                          class="mt-n1"
                          dark
                          v-bind="attrs"
                          v-on="on"
                          >
                          mdi-alert-circle
                        </v-icon>
                      </template>
                      <span>Con intereses {{ charge.chargebacks[0].active ? 'habilitados' : 'deshabilitados' }}</span>
                    </v-tooltip>
                  </template>

                  <template
                    v-if="charge.children.length"
                    >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          color="primary"
                          size="20"
                          class="mt-n1"
                          dark
                          v-bind="attrs"
                          v-on="on"
                          >
                          mdi-source-branch
                        </v-icon>
                      </template>
                      <span>Contiene pagos parciales</span>
                    </v-tooltip>
                  </template>

                  <div
                    style="position: relative"
                    >
                    <div>
                      {{ price(charge.amount, charge.currency) }}
                    </div>

                    <div
                      v-if="(charge.lastingAmount != charge.amount) && !charge.parentId"
                      class="caption"
                      >
                      {{ price(charge.lastingAmount, charge.currency) }}
                    </div>

                    <v-tooltip
                      v-if="!charge.amount"
                      color="primary"
                      bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          color="primary"
                          dark
                          v-bind="attrs"
                          v-on="on"
                          small
                          style="position: absolute; top: -12px; right: -12px"
                          >
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>Haga click en el monto para editar el valor del cobro.</span>
                    </v-tooltip>
                  </div>
                </div>
              </v-col>

              <v-col
                cols="2"
                :class="charge.total >= 0 ? '' : 'red--text'"
                @click="select(charge)"
                >
                <div
                  v-if="charge.total >= 0"
                  class="text-right font-weight-medium d-flex justify-end align-center"
                  :style="!(charge.concept == 'Alquiler' && i == 0) ? 'margin-right: 8px' : ''"
                  style="cursor: pointer; gap: 8px"
                  >
                  <template
                    v-if="charge.differential"
                    >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          color="primary"
                          size="20"
                          class="mt-n1"
                          dark
                          v-bind="attrs"
                          v-on="on"
                          >
                          mdi-alert-circle
                        </v-icon>
                      </template>
                      <span>Diferencia de pago en pagaré</span>
                    </v-tooltip>
                  </template>

                  <template
                    v-if="charge.chargebacks.length"
                    >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          color="primary"
                          size="20"
                          class="mt-n1"
                          dark
                          v-bind="attrs"
                          v-on="on"
                          >
                          mdi-alert-circle
                        </v-icon>
                      </template>
                      <span>Con intereses {{ charge.chargebacks[0].active ? 'habilitados' : 'deshabilitados' }}</span>
                    </v-tooltip>
                  </template>

                  <template
                    v-if="charge.children.length"
                    >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          color="primary"
                          size="20"
                          class="mt-n1"
                          dark
                          v-bind="attrs"
                          v-on="on"
                          >
                          mdi-source-branch
                        </v-icon>
                      </template>
                      <span>Contiene pagos parciales</span>
                    </v-tooltip>
                  </template>

                  <div
                    style="position: relative"
                    >
                    <div>
                      {{ price(charge.amount, charge.currency) }}
                    </div>

                    <div
                      v-if="(charge.lastingAmount != charge.amount) && !charge.parentId"
                      class="caption"
                      >
                      {{ price(charge.lastingAmount, charge.currency) }}
                    </div>

                    <v-tooltip
                      v-if="!charge.amount"
                      color="primary"
                      bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          color="primary"
                          dark
                          v-bind="attrs"
                          v-on="on"
                          small
                          style="position: absolute; top: -12px; right: -12px"
                          >
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>Haga click en el monto para editar el valor del cobro.</span>
                    </v-tooltip>
                  </div>
                </div>
              </v-col>

              <v-col
                cols="3"
                class="text-right"
                >
                <template>
                  <template
                    v-if="charge.paidAt"
                    >
                    {{ (new Date(charge.paidAt)).toLocaleDateString() }}
                  </template>

                  <template
                    v-else
                    >
                    <div>
                      Pendiente
                    </div>
                  </template>
                </template>
              </v-col>

              <v-col
                cols="12"
                class="mt-2"
                >
                <v-divider
                  v-if="!(charge.concept == 'Alquiler' && i == 0)"
                  ></v-divider>
              </v-col>
            </v-row>
          </div>
        </template>

        <div
          v-if="expenses.length"
          >
          <div
            class="d-flex align-center ml-8"
            style="gap: 8px; cursor: pointer; border: 1px solid #586279; margin-top: -1px"
            @click="expandExpenses = !expandExpenses"
            >
            <div
              class="pl-3"
              >
              <v-icon
                color="primary"
                >
                {{ expandExpenses ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
              </v-icon>
            </div>

            <v-row
              no-gutters
              class="my-2"
              align="center"
              >
              <v-col
                cols="7"
                class="d-flex align-center"
                style="height: 42px"
                >
                Expensas
              </v-col>

              <v-col
                cols="2"
                class="text-right font-weight-medium d-flex justify-end align-center ml-n4"
                style="height: 42px"
                >
                {{ price(expensesAmount) }}
              </v-col>
            </v-row>
          </div>

          <v-expand-transition>
            <div
              v-if="expandExpenses"
              class="d-flex flex-row align-stretch pl-14 pr-2"
              style="gap: 12px"
              >
              <v-divider
                vertical
                ></v-divider>

              <div
                style="flex: 1"
                >
                <template
                  v-for="charge in expenses"
                  >
                  <div
                    class="d-flex align-center"
                    style="gap: 8px"
                    >
                    <div>
                      <v-icon
                        color="primary"
                        @click.stop="pay(charge)"
                        >
                        {{ charge.state == 'paid' ? 'mdi-check-circle' : 'mdi-check-circle-outline' }}
                      </v-icon>
                    </div>

                    <v-row
                      no-gutters
                      class="mt-2"
                      align="center"
                      >
                      <v-col
                        cols="5"
                        class="d-flex flex-row"
                        style="gap: 4px"
                        >
                        <template
                          v-if="charge.parentId"
                          >
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                color="primary"
                                size="20"
                                class="mt-n1"
                                dark
                                v-bind="attrs"
                                v-on="on"
                                >
                                mdi-source-branch
                              </v-icon>
                            </template>
                            <span>Es un pago parcial</span>
                          </v-tooltip>
                        </template>

                        <div>
                          <div
                            class="caption"
                            >
                            #{{ charge.id }} {{ charge.taxableTag == 'Building' ? '- Expensas' : '' }}
                          </div>

                          <div>
                            {{ charge.concept }} - {{ (new Date(charge.dueDate)).toLocaleString('default', { month: 'long' }) }}
                          </div>
                        </div>
                      </v-col>

                      <v-col
                        cols="2"
                        class="text-right font-weight-medium d-flex justify-end align-center"
                        :class="charge.total >= 0 ? '' : 'red--text'"
                        @click="select(charge)"
                        style="cursor: pointer; gap: 8px"
                        >
                        <div
                          v-if="charge.total < 0"
                          class="mr-4"
                          >
                          <template
                            v-if="charge.differential"
                            >
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  color="primary"
                                  size="20"
                                  class="mt-n1"
                                  dark
                                  v-bind="attrs"
                                  v-on="on"
                                  >
                                  mdi-alert-circle
                                </v-icon>
                              </template>
                              <span>Diferencia de pago en pagaré</span>
                            </v-tooltip>
                          </template>

                          <template
                            v-if="charge.chargebacks.length"
                            >
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  color="primary"
                                  size="20"
                                  class="mt-n1"
                                  dark
                                  v-bind="attrs"
                                  v-on="on"
                                  >
                                  mdi-alert-circle
                                </v-icon>
                              </template>
                              <span>Con intereses {{ charge.chargebacks[0].active ? 'habilitados' : 'deshabilitados' }}</span>
                            </v-tooltip>
                          </template>

                          <template
                            v-if="charge.children.length"
                            >
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  color="primary"
                                  size="20"
                                  class="mt-n1"
                                  dark
                                  v-bind="attrs"
                                  v-on="on"
                                  >
                                  mdi-source-branch
                                </v-icon>
                              </template>
                              <span>Contiene pagos parciales</span>
                            </v-tooltip>
                          </template>

                          <div>
                            <div>
                              {{ price(charge.amount, charge.currency) }}
                            </div>

                            <div
                              v-if="charge.lastingAmount != charge.amount"
                              class="caption"
                              >
                              {{ price(charge.lastingAmount, charge.currency) }}
                            </div>
                          </div>
                        </div>
                      </v-col>

                      <v-col
                        cols="2"
                        class="text-right font-weight-medium d-flex justify-end align-center"
                        :class="charge.total >= 0 ? '' : 'red--text'"
                        @click="select(charge)"
                        style="cursor: pointer; gap: 8px"
                        >
                        <div
                          v-if="charge.total >= 0"
                          class="mr-4"
                          >
                          <template
                            v-if="charge.differential"
                            >
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  color="primary"
                                  size="20"
                                  class="mt-n1"
                                  dark
                                  v-bind="attrs"
                                  v-on="on"
                                  >
                                  mdi-alert-circle
                                </v-icon>
                              </template>
                              <span>Diferencia de pago en pagaré</span>
                            </v-tooltip>
                          </template>

                          <template
                            v-if="charge.chargebacks.length"
                            >
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  color="primary"
                                  size="20"
                                  class="mt-n1"
                                  dark
                                  v-bind="attrs"
                                  v-on="on"
                                  >
                                  mdi-alert-circle
                                </v-icon>
                              </template>
                              <span>Con intereses {{ charge.chargebacks[0].active ? 'habilitados' : 'deshabilitados' }}</span>
                            </v-tooltip>
                          </template>

                          <template
                            v-if="charge.children.length"
                            >
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  color="primary"
                                  size="20"
                                  class="mt-n1"
                                  dark
                                  v-bind="attrs"
                                  v-on="on"
                                  >
                                  mdi-source-branch
                                </v-icon>
                              </template>
                              <span>Contiene pagos parciales</span>
                            </v-tooltip>
                          </template>

                          <div>
                            <div>
                              {{ price(charge.amount, currency) }}
                            </div>

                            <div
                              v-if="charge.lastingAmount != charge.amount"
                              class="caption"
                              >
                              {{ price(charge.lastingAmount, charge.currency) }}
                            </div>
                          </div>
                        </div>
                      </v-col>

                      <v-col
                        cols="3"
                        class="text-right"
                        >
                        <template>
                          <template
                            v-if="charge.paidAt"
                            >
                            {{ (new Date(charge.paidAt)).toLocaleDateString() }}
                          </template>

                          <template
                            v-else
                            >
                            <div>
                              Pendiente
                            </div>
                          </template>
                        </template>
                      </v-col>

                      <v-col
                        cols="12"
                        class="my-2"
                        >
                        <v-divider></v-divider>
                      </v-col>
                    </v-row>
                  </div>
                </template>
              </div>
            </div>
          </v-expand-transition>
        </div>
      </div>
    </v-expand-transition>

    <v-divider
      class="white fill-width"
      ></v-divider>
  </div>
</template>

<script>
import Edit from './Edit'

import { Pay } from '@/graphql/mutations/payments'

export default {
  data: () => ({
    expand: false,
    selected: null,
    expenses: [],
    expensesAmount: null,
    expandExpenses: true,
  }),

  props: {
    payment: {
      type: Array,
      required: true
    },

    client: {
      type: Object,
      required: true
    },

    expanded: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  watch: {
    payment () {
      this.fillExpenses()
    }
  },

  created () {
    this.fillExpenses()
  },

  computed: {
    orderedCharges () {
      var ordered = this.payment[1].sort( (a, b) => {
        if (a.concept.toUpperCase() < b.concept.toUpperCase()) {
          return 1;
        }
        if (a.concept.toUpperCase() > b.concept.toUpperCase()) {
          return -1;
        }
        // a must be equal to b
        return 0;
      })

      ordered = ordered.sort( (x,y) => {
        return (x.concept == 'Alquiler' && (x.referralType == 'User' && x.referralId == this.client.id)) ? -1 : (y.concept == 'Alquiler' && (y.referralType == 'User' && y.referralId == this.client.id)) ? 1 : 0; 
      });

      return ordered
    }
  },

  created () {
    this.expand = this.expanded
  },

  methods: {
    fillExpenses () {
      this.expenses = []
      this.expensesAmount = 0

      this.payment[1].forEach ( payment => {
        if (payment.taxableTag == 'Building') {
          this.expenses.push(payment)
          this.expensesAmount += payment.total
        }
      })
    },

    price (amount, currency = 'ARS') {
      const options = { style: 'currency', currency: currency };
      const numberFormat = new Intl.NumberFormat('es-AR', options);

      return numberFormat.format(Math.abs(amount))
    },

    redirect () {
      let routeData = this.$router.resolve({name: 'Contract', params: { id: this.payment[1][0].contract.id }});
      window.open(routeData.href, '_blank');
    },

    pay (charge) {
      this.loading = true

      this.$apollo.mutate({
        mutation: Pay,
        variables: {
          input: {
            paymentId: charge.id,
            setReceipt: true,
            receiptType: 'tenant'
          }
        },
        fetchPolicy: 'no-cache'
      }).then(res => {
        this.loading = false
        charge.state = charge.state == 'paid' ?  'pending' : 'paid'
        charge.paidAt = charge.state == 'paid' ? (new Date) : null

        this.$emit('reload')
      })
    },

    select (payment) {
      this.selected = payment

      this.$nextTick( () => {
        this.$refs.edit.dialog = true
      })
    },
  },

  components: {
    Edit
  }
}
</script>
